import React from "react";
import NotificationList from "../organisms/NotificationList";

export default function NotificationHistoryTemplate() {
  return <NotificationList />;
}